export default "__VITE_ASSET__CONnsbyA__"